module.exports = __webpack_public_path__ + "img/Loading_r_37.03512d33.png";